module.exports = __webpack_public_path__ + "img/VideoButtonNavigation.158758db.png";